import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { Spin } from 'antd';
export const LazyPage = ({ page }) => {
    const Page = lazy(() => import(`@page/${page}`));
    return (_jsx(Suspense, { fallback: _jsx(Spin, {}), children: _jsx(Page, {}) }));
};
